import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿En qué formato recibo el material?',
    a: '100% digital, listo para descargar e imprimir.'
  }, {
    q: '¿Puedo imprimirlo?',
    a: 'Sí, sin restricciones.'
  }, {
    q: '¿Para qué grados sirve?',
    a: 'De 1° a 6° grado.'
  }, {
    q: '¿Está adaptado al diseño curricular?',
    a: 'Es adaptable a la currícula vigente de primaria.'
  }, {
    q: '¿Cuánto tarda en llegar?',
    a: 'Acceso inmediato tras la compra.'
  }];
  return <section className="w-full bg-white py-10 px-4 md:px-8" data-id="element-39">
      <div className="max-w-3xl mx-auto" data-id="element-40">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-6" data-id="element-41">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-42">
          {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-43">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex justify-between items-center p-4 bg-gray-50 hover:bg-gray-100 transition-colors text-left" data-id="element-44">
                <span className="font-bold text-gray-900 text-base" data-id="element-45">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUpIcon className="w-5 h-5 text-gray-500" data-id="element-46" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-47" />}
              </button>

              {openIndex === i && <div className="p-4 bg-white text-gray-700" data-id="element-48">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}